import React, { useState, useEffect, useCallback } from "react";
import Autosuggest from "react-autosuggest";
import axios from 'axios';
import { API_URL } from '../helpers/config';
import debounce from '../helpers/debounce';

axios.defaults.withCredentials = true;

const SearchByLastName = ({ value, onSuggestionSelected, placeholder, onClick }) => {
  const [suggestions, setSuggestions] = useState([]);

  // Función para buscar en el backend
  const fetchSuggestions = async (inputValue) => {
    try {
      if (!inputValue || inputValue.length < 1) {
        setSuggestions([]);
        return;
      }

      const response = await axios.get(`${API_URL}/?surname=${inputValue}&mode=partial`);
      const data = response.data;

      // Extraer apellidos únicos concatenados para mostrar
      const uniqueLastNames = new Set();
      const formattedSuggestions = [];

      data.forEach(persona => {
        const apellido1 = (persona.apellido1 || '').trim();
        const apellido2 = (persona.apellido2 && persona.apellido2 !== 'null') ? persona.apellido2.trim() : '';
        const fullLastName = `${apellido1} ${apellido2}`.trim();

        if (fullLastName && !uniqueLastNames.has(fullLastName)) {
          uniqueLastNames.add(fullLastName);
          formattedSuggestions.push({ fullLastName });
        }
      });

      formattedSuggestions.sort((a, b) => a.fullLastName.localeCompare(b.fullLastName));
      setSuggestions(formattedSuggestions);

    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  // Debounce de la función de búsqueda
  const debouncedFetch = useCallback(debounce((inputValue) => fetchSuggestions(inputValue), 300), []);

  const onSuggestionsFetchRequested = ({ value }) => {
    debouncedFetch(value);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const getSuggestionValue = (suggestion) => suggestion.fullLastName;

  const renderSuggestion = (suggestion, { isHighlighted }) => (
    <div className={`suggestion-item ${isHighlighted ? "highlighted" : ""}`}>
      {suggestion.fullLastName}
    </div>
  );

  return (
    <div className="suggestion-wrapper">
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={{
          placeholder: placeholder || "Apellidos",
          value: value,
          onChange: (_, { newValue }) => onSuggestionSelected(newValue), // Actualiza el input visual
          onClick: onClick,
          onSelect: (e) => {
            if (value) {
              e.target.setSelectionRange(e.target.value.length, e.target.value.length);
            }
          },
          onKeyDown: (e) => {
            if (value && e.shiftKey && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
              e.preventDefault();
            }
          },
          style: {
            width: "100%",
            height: "40px",
            padding: "8px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
            userSelect: value ? "none" : "auto",
            caretColor: value ? "transparent" : "auto"
          },
        }}
        onSuggestionSelected={(_, { suggestion }) => {
          onSuggestionSelected(suggestion.fullLastName, true); // True indica que es una selección final
        }}
      />
    </div>
  );
};

export default SearchByLastName;